module.exports = __webpack_public_path__ + "static/media/acura-star.d3b0a15f.svg";